import { HtmlParser } from '@calendly/html-parser'
import { I18n } from '@calendly/i18n'
import { FlexLayout } from '@calendly/ui/components/flex-layout'
import { Link } from '@calendly/ui/components/link'
import { TitleText } from '@calendly/ui/components/typography'

import { Divider } from 'features/organization_settings/data_deletion/styles'
import { SETTINGS_SECTION } from 'features/settings_modal/constants'
import {
  getSettingsNavigationLinkProps,
  useSettingsNavigation,
} from 'features/settings_modal/use_settings_navigation'

const profilePath = '/app/personal/profile'

const DeletionLink = ({ children }) => {
  const { hrefForSettingsSection, navigateToSettingsSection } = useSettingsNavigation()
  const profileSettingsTarget = hrefForSettingsSection(SETTINGS_SECTION.profile, profilePath)
  const profileSettingsLinkProps = getSettingsNavigationLinkProps({
    target: profileSettingsTarget,
    navigate: () => navigateToSettingsSection(SETTINGS_SECTION.profile, {
      legacyPath: profilePath,
    }),
  })

  return (
    <Link {...profileSettingsLinkProps}>{children}</Link>
  )
}

export const AccountSection = () => (
  <>
    <Divider />
    <FlexLayout direction="column" gap={24}>
      <TitleText level={3} size="x-small">
        {I18n.t('publisher.organization_settings.data_deletion.section.account.title')}
      </TitleText>
      <FlexLayout direction="column" gap={16}>
        <div data-testid="sub-description">
          {
        HtmlParser(
          I18n.t('publisher.organization_settings.data_deletion.section.account.description'),
          { DeletionLink }
        )
      }
        </div>
      </FlexLayout>
    </FlexLayout>
  </>
)
